import gql from 'graphql-tag'

export const GET_USER_LIST_QUERY = gql`
  query user_list {
    user_list {
      id
      username
      email
    }
  }
`
